import React from 'react'
import CircularProgress from '@material-ui/core/CircularProgress'

const LoadingIndicator = ({
  label = 'Loading',
  style,
  labelStyle,
  percentage,
  ...props
}) => {
  return (
    <section
      style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        flexDirection: 'column',
        width: '100%',
        height: '100%',
        maxHeight: '100vh',
        padding: '8px',
        ...style,
      }}
    >
      <CircularProgress {...props} />

      <span
        style={{
          marginTop: '12px',
          ...labelStyle,
        }}
      >
        {label}
      </span>
      {!!percentage && (
        <span
          style={{
            marginTop: '5px',
          }}
        >
          {percentage} %
        </span>
      )}
    </section>
  )
}

export default LoadingIndicator
